export default {"src":"/_next/static/image/public/images/flags/flag_249.50a6e109fbf15104a5ee64a6b2486095.svg","height":16,"width":24};